module.exports = __webpack_public_path__ + "img/heart.a7d93f88.svg";